import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import SimpleBookDetailsContainer from "./SimpleBookDetailsContainer";
import BookResourcesContainer from "../../panel/tabs/BookResourcesContainer";
import { Tab, Tabs, TabList, TabPanel } from "../../../../../components/tabs";
import { Translation } from "../../../../../core/translate";
import { selectors as routerSelectors } from "../../../../../../redux/router";
import { selectors as bridgeSelectors } from "../../../../../../redux/bridge";
import { OffScreenStyles } from "../../../../../components/mixins";
import { withAllMatches } from "../../../../../components/mediaquery/breakpoints";
import {
  selectors as uiLibrarySelectors,
  actions as uiLibraryActions
} from "../../../../../../redux/ui/library";
import { BridgeHeader } from "../../../panel/header";

const WrapperOuter = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const TabBar = styled(Tabs)`
  padding-top: 15px;
  height: 100%;
  position: relative;
`;

const defaultTabs = {
  listStyle: "none",
  display: "flex",
  justifyContent: "normal",
  margin: "0",
  width: "100%",
  whiteSpace: "nowrap",
  overflowX: "auto"
};

const TabBarText = styled(Tab)`
  flex: 1;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  display: flex;
  font-size: 1.6rem;
  font-weight: 500;
  color: ${cloud.getShade(10)};
  border-right: ${cloud.getShade(4)} solid 1px;
  position: relative;
  height: 35px;
  min-width: 30%;
  &:last-child {
    border: none;
  }
  span {
    span {
      padding: 0 10px 5px;
    }
  }
  &.react-tabs__tab--selected {
    span {
      span {
        border-bottom: solid ${props => props.theme.color.secondary.getShade(6)}
          4px;
      }
    }
  }
`;

const TabPanelContainer = styled.div`
  position: absolute;
  top: 55px;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
`;

const TabPanelInner = styled(TabPanel)`
  &.react-tabs__tab-panel--selected {
    height: 100%;
  }
`;

const TabsContainer = ({
  isbn,
  asset,
  panel,
  changePanelTab,
  native,
  nativePlatform,
  distributable
}) => {
  const tabs = [
    {
      tabID: "details",
      tabText: <Translation id="library.details">Details</Translation>,
      tabPanel: <SimpleBookDetailsContainer isbn={isbn} />
    }
  ];
  if (
    asset != null &&
    asset.hasAncillaries &&
    (!native || nativePlatform === "web") &&
    (asset.active || (!asset.active && distributable))
  ) {
    tabs.push({
      tabID: "resources",
      tabText: <Translation id="filter.resources">Resources</Translation>,
      tabPanel: <BookResourcesContainer isbn={isbn} source="bridge" />
    });
  }
  const selectedIndex = tabs.findIndex(tab => panel.data.tab === tab.tabID);
  const tabStyles = tabs.length > 1 ? defaultTabs : OffScreenStyles;

  const SingleTab = (
    <div>
      <BridgeHeader isbn={isbn} />
      <SimpleBookDetailsContainer isbn={isbn} />
    </div>
  );

  const TabsContainer = (
    <div>
      <BridgeHeader isbn={isbn} />
      <TabBar
        selectedIndex={Math.max(0, selectedIndex)}
        onSelect={index => changePanelTab(tabs[index].tabID)}
      >
        <TabList style={tabStyles}>
          {tabs.map(tab => (
            <TabBarText key={`tab-${tab.tabID}`}>{tab.tabText}</TabBarText>
          ))}
        </TabList>
        <TabPanelContainer>
          {tabs.map(tab => (
            <TabPanelInner key={`panel-${tab.tabID}`}>
              {tab.tabPanel}
            </TabPanelInner>
          ))}
        </TabPanelContainer>
      </TabBar>
    </div>
  );

  return (
    <WrapperOuter>{tabs.length <= 1 ? SingleTab : TabsContainer}</WrapperOuter>
  );
};

const mapStateToProps = (state, props) => ({
  native: routerSelectors.isNative(state),
  nativePlatform: routerSelectors.getQueryParam(state, "platform"),
  panel: uiLibrarySelectors.getPanel(state),
  asset: bridgeSelectors.getAsset(state, props.isbn),
  distributable: bridgeSelectors.isDistributable(state, props.isbn)
});

const mapDispatchToProps = (dispatch, props) => ({
  changePanelTab: tab => dispatch(uiLibraryActions.changePanelTab(tab))
});

export default withAllMatches(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(TabsContainer))
);
